import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, TextField } from "@mui/material";
import { Form, Input, Button, message, Select, Upload, Col } from "antd";
import { useNavigate, useParams } from "react-router-dom";

import { Row, Image } from "antd";

import Dragger from "antd/es/upload/Dragger";
import { UploadOutlined } from "@ant-design/icons";
import useSelection from "antd/es/table/hooks/useSelection";


import SearchIcon from "@mui/icons-material/Search";
import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import SearchBar from "../../Components/SearchBar";
import { BorderBottom } from "@mui/icons-material";
import appColors from "../../config/appColors";
import { postRequest, postRequestFormData } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import VehicleView from "../../Components/VehicleView";
import { VEH_IMAGE_URL } from "../../Api/constants";
import { selectStyle } from "../../css/styles";
import { yyyymmdd } from "../../config/functions";
const { Option } = Select;


const Addvehicle = () => {

    const { id } = useParams();

    const theme = useTheme();
    const dispatch = useDispatch();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Adjust breakpoint as needed
    const user = useSelector((state) => state.authReducer.user);

    const [activeTab, setActiveTab] = React.useState('dashboard');
    const [vehicles, setVehicles] = useState([]);
    const [form] = Form.useForm();

    const history = useNavigate();

    const [vehicleName, setVehicleName] = useState("");
    const [regNo, setRegNo] = useState("");
    const [make, setMake] = useState("");
    const [model, setModel] = useState("");
    const [year, setYear] = useState("");
    const [transmission, setTransmission] = useState("");
    const [mileage, setMileage] = useState("");
    const [airBags, setAirBags] = useState("");
    const [fuelType, setFuelType] = useState("");
    const [seats, setSeats] = useState("");
    const [rent, setRent] = useState("");
    const [bodyType, setBodyType] = useState("");
    const [images, setImages] = useState([]);
    const [rentalDetails, setRentalDetails] = useState('');
    const [deletedVehicles, setDeletedVehicles] = useState([]);
    const [color, setColor] = useState("")

    const [vehicle, setVehicle] = useState();

    const [licenseExpDate, setLicenseExpDate] = useState('');
    const [motTestDate, setMotTestDate] = useState('');
    const [motExpDate, setMotExpDate] = useState('');
    const [taxExpDate, setTaxExpDate] = useState('');

    const [existingDocuments, setExistingDocuments] = useState([]);
    const [deletedDocIds, setDeletedDocIds] = useState([]);
    const [newDocumentList, setNewDocumentList] = useState([]);




    const getVehicleDetails = async () => {
        const onSuccess = (res) => {
            setVehicle(res.data);
            console.log('vehicle?.images', res.data?.images)
            const data = res.data;
            setVehicleName(data.veh_name);
            setRegNo(data.reg_no);
            setMake(data.make);
            setModel(data.model);
            setYear(data.year);
            setTransmission(data.transmission);
            setMileage(data.milage);
            setAirBags(data.air_bags);
            setFuelType(data.fuel_type);
            setSeats(data.seats);
            setRent(data.rent);
            setBodyType(data.body_type);
            setRentalDetails(data.rental_details);
            setColor(data.color);
            setImages(data.images ?? []);

            // alert(yyyymmdd(data?.license_exp_date))

            setLicenseExpDate(yyyymmdd(data?.license_exp_date));
            setMotTestDate(yyyymmdd(data?.mot_test_date));
            setMotExpDate(yyyymmdd(data?.mot_exp_date));
            setTaxExpDate(yyyymmdd(data?.tax_exp_date));

            setExistingDocuments(res.documents || []);



            dispatch(setLoader(false));
        }
        const onError = (err) => {
            console.log('err', err)
            err?.data?.error && alert(err.data.error);
            dispatch(setLoader(false));
        }

        const body = {
            veh_id: id,
            token: user?.token
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.getVehicleDetails, onSuccess, onError);


    }

    const onFinish = async () => {
        // Your API call logic goes here
        // You can send the data to your API using a library like Axios or fetch
        // Example:
        if (!images.length) {
            message.error('Please add atleast one vehicle image');
            return;
        }
        const data = {
            token: user?.token,
            veh_name: vehicleName,
            reg_no: regNo,
            make: make,
            model: model,
            year: year,
            transmission: transmission,
            milage: mileage,
            air_bags: airBags,
            fuel_type: fuelType,
            seats: seats,
            rent: rent,
            body_type: bodyType,
            rental_details: rentalDetails,


            'images[]': images,
        };
    }


    const newDocumentUploadProps = {
        onRemove: (file) => {
            setNewDocumentList((prev) => prev.filter((item) => item.uid !== file.uid));
        },
        beforeUpload: (file) => {
            const newFile = { uid: file.uid, name: file.name, originFileObj: file, docType: 'other' };
            setNewDocumentList((prev) => [...prev, newFile]);
            return false;
        },
        fileList: newDocumentList,
        multiple: true,
    };

    // Handle doc type change
    const handleNewDocTypeChange = (value, uid) => {
        setNewDocumentList(prev => prev.map(doc => doc.uid === uid ? { ...doc, docType: value } : doc));
    };

    // Remove existing document
    const removeExistingDoc = (doc_id) => {
        setDeletedDocIds([...deletedDocIds, doc_id]);
        setExistingDocuments(prev => prev.filter(doc => doc.doc_id !== doc_id));
    };


    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    const doEditVehicle = () => {
        // Basic validation
        if (images?.length === 0 && vehicle.images?.length === deletedVehicles.length) {
            message.error("Please keep at least one vehicle image");
            return;
        }

        const onSuccess = (res) => {
            console.log('res', res);
            dispatch(setLoader(false));
            message.success("Vehicle updated successfully!");
            history("/vehicles");
        };

        const onError = (err) => {
            console.log('error', err);
            dispatch(setLoader(false));
            message.error(err?.error ?? err?.data?.error ?? "Failed to update vehicle");
        };

        // Create FormData
        const formData = new FormData();

        // Token & ID
        formData.append("token", user?.token);
        formData.append("veh_id", id);

        // Basic Fields
        formData.append("veh_name", vehicleName);
        formData.append("reg_no", regNo.toUpperCase());
        formData.append("make", make || "");
        formData.append("model", model || "");
        formData.append("year", year || "");
        formData.append("transmission", transmission || "");
        formData.append("milage", mileage || "");
        formData.append("air_bags", airBags || "");
        formData.append("fuel_type", fuelType || "");
        formData.append("seats", seats || "");
        formData.append("rent", rent || "");
        formData.append("body_type", bodyType || "");
        formData.append("rental_details", rentalDetails || "");
        formData.append("color", color || "");
        formData.append("deleted_images", JSON.stringify(deletedVehicles));

        for (let key1 of images) {
            formData.append('images[]', key1);
        }



        // Dates (only if changed or exist)
        if (licenseExpDate) formData.append("license_exp_date", licenseExpDate);
        if (motTestDate) formData.append("mot_test_date", motTestDate);
        if (motExpDate) formData.append("mot_exp_date", motExpDate);
        if (taxExpDate) formData.append("tax_exp_date", taxExpDate);

        // === IMAGES HANDLING ===
        // Deleted images (from existing)
        if (deletedVehicles.length > 0) {
            formData.append("deleted_images", JSON.stringify(deletedVehicles));
        }

        // New uploaded images (from Ant Design Upload)


        // === DOCUMENTS HANDLING ===
        // Deleted existing documents
        if (deletedDocIds.length > 0) {
            formData.append("deleted_documents", JSON.stringify(deletedDocIds));
        }

        // New uploaded documents
        newDocumentList.forEach((doc) => {
            formData.append("documents[]", doc.originFileObj);
            formData.append("doc_type[]", doc.docType || "other");
        });

        // Debug (optional - remove in production)
        // for (let pair of formData.entries()) {
        //   console.log(pair[0], pair[1]);
        // }

        dispatch(setLoader(true));

        // Send FormData directly
        postRequestFormData(
            formData, // Direct FormData object
            apiRoutes.editVehicle,
            onSuccess,
            onError
        );
    };

    // const doEditVehicle = () => {
    //     const onSuccess = (res) => {
    //         console.log('res', res)
    //         dispatch(setLoader(false))
    //         message.success("Vehicle updated successfully!");
    //         history("/vehicles");
    //     }
    //     const onError = (err) => {
    //         console.log('error', err);
    //         dispatch(setLoader(false))
    //         alert(err?.data?.error);
    //     }

    //     const data = {
    //         token: user?.token,
    //         veh_id: id,
    //         veh_name: vehicleName,
    //         reg_no: regNo,
    //         make: make,
    //         model: model,
    //         year: year,
    //         transmission: transmission,
    //         milage: mileage,
    //         air_bags: airBags,
    //         fuel_type: fuelType,
    //         seats: seats,
    //         rent: rent,
    //         body_type: bodyType,
    //         rental_details: rentalDetails,
    //         color: color,

    //         license_exp_date: new Date(licenseExpDate).toISOString(),
    //         mot_test_date: new Date(motTestDate).toISOString(),
    //         mot_exp_date: new Date(motExpDate).toISOString(),
    //         tax_exp_date: new Date(taxExpDate).toISOString(),

    //         'images[]': images,
    //         'deleted_images': JSON.stringify(deletedVehicles)
    //     };
    //     console.log('data', data);
    //     // return;
    //     dispatch(setLoader(true));
    //     postRequestFormData(data, apiRoutes.editVehicle, onSuccess, onError);
    // }


    const removeImages = (image) => {
        const newImages = vehicle.images.filter((img) => img !== image);
        setDeletedVehicles([...deletedVehicles, image]);
        setVehicle({ ...vehicle, images: newImages });
    }

    useEffect(() => {
        getVehicleDetails();
    }, [])


    if (!vehicle) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <ThemeProvider theme={theme}>
                <div style={{ display: 'flex', }}>
                    <Sidebars />

                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 20, width: "75%" }} >
                        <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                            Edit new vehicle
                        </span>
                        <div style={{ display: 'flex', flexDirection: 'column', width: "100%", borderRadius: 10, backgroundColor: appColors.white, marginTop: 10, paddingBottom: 20 }}>
                            <div style={{ width: "100%", height: 45, borderTopRightRadius: 10, borderTopLeftRadius: 10, backgroundColor: appColors.primary }}>
                                <Typography style={{ color: appColors.white, fontSize: 16, fontWeight: 600, marginLeft: 20, marginTop: 10 }}>Vehicle Information</Typography>
                            </div>

                            <Form
                                style={{ width: "100%", paddingRight: 20, paddingLeft: 20 }}
                                initialValues={{
                                    vehicleName: vehicle.veh_name,
                                    reg_no: vehicle.reg_no,
                                    make: vehicle.make,
                                    model: vehicle.model,
                                    year: vehicle.year,
                                    transmission: vehicle.transmission,
                                    mileage: vehicle.milage,
                                    airBags: vehicle.air_bags == "1" ? "Yes" : "No",
                                    fuelType: vehicle.fuel_type,
                                    seats: vehicle.seats,
                                    rent: vehicle.rent,
                                    bodyType: vehicle.body_type,
                                    rentalDetails: vehicle.rental_details,
                                    images: vehicle.images,
                                }}
                                layout="vertical"
                                form={form}
                                onFinish={() => doEditVehicle()}
                                onFinishFailed={() => onFinishFailed()}
                            >
                                {/* Vehicle Name */}
                                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: "100%", justifyContent: 'space-between', marginTop: 20 }} >
                                    <Form.Item

                                        name="vehicleName"
                                        rules={[{ required: true, message: "Please enter the vehicle name!" }]}
                                    >
                                        <Typography style={labelStyle}>Vehicle Name</Typography>
                                        <Input
                                            className="textInput"
                                            value={vehicleName}
                                            onChange={(e) => setVehicleName(e.target.value)}
                                        />
                                    </Form.Item>

                                    {/* Make */}
                                    <Form.Item

                                        // labelCol={2}
                                        // label="Reg no" 
                                        name="reg_no"
                                        rules={[{ required: true, message: "Please enter the registration number!" }]}
                                    >
                                        <Typography style={labelStyle}>Reg no</Typography>
                                        <Input
                                            className="textInput"
                                            value={regNo}
                                            onChange={(e) => setRegNo(e.target.value)} />
                                    </Form.Item>
                                    <Form.Item
                                        // labelCol={1}
                                        // style={{ width: "50%" }}

                                        // label="Make"
                                        name="make"
                                        rules={[{ required: true, message: "Please enter the make!" }]}
                                    >
                                        <Typography style={labelStyle}>Make</Typography>
                                        <Input
                                            className="textInput"
                                            value={make} onChange={(e) => setMake(e.target.value)} />
                                    </Form.Item>

                                    <Form.Item

                                        // labelCol={2}
                                        // style={{ marginLeft: -20, width: "50%" }}
                                        // label="Model"
                                        name="model"
                                        rules={[{ required: true, message: "Please enter the model!" }]}>
                                        <Typography style={labelStyle}>Model</Typography>
                                        <Input
                                            className="textInput"
                                            value={model} onChange={(e) => setModel(e.target.value)} />
                                    </Form.Item>



                                </div>

                                {/* Year */}
                                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between', }} >

                                    <Form.Item

                                        // labelCol={1}
                                        // style={{ width: "50%" }}
                                        // label="Year"
                                        name="year"
                                        rules={[{ required: true, message: "Please enter the year!" }]}
                                    >
                                        <Typography style={labelStyle}>Year</Typography>
                                        <Input
                                            className="textInput"
                                            value={year} onChange={(e) => setYear(e.target.value)} />
                                    </Form.Item>

                                    <Form.Item

                                        // labelCol={2}
                                        // style={{ marginLeft: -20, width: "50%" }}
                                        name="seats" rules={[{ required: true, message: "Please enter the number of seats!" }]}
                                    >
                                        <Typography style={labelStyle}>Seats</Typography>
                                        <Input
                                            className="textInput"
                                            value={seats} onChange={(e) => setSeats(e.target.value)} />
                                    </Form.Item>


                                    {/* Transmission */}
                                    <Form.Item

                                        // labelCol={2}
                                        // style={{ marginLeft: -20, width: "50%" }}
                                        // label="Transmission"
                                        name="transmission"
                                        rules={[{ required: true, message: "Please select the transmission!" }]}
                                    >
                                        <Typography style={labelStyle}>Transmission</Typography>
                                        <Select
                                            style={selectStyle}
                                            className="textInput"
                                            placeholder="Select a Transmission" value={transmission}
                                            onChange={(value) => setTransmission(value)}>
                                            <Option value="Manual">Manual</Option>
                                            <Option value="Automatic">Automatic</Option>
                                        </Select>
                                    </Form.Item>


                                    <Form.Item
                                        // labelCol={2}
                                        // style={{ marginLeft: -20, width: "50%" }}
                                        // label="Body Type"
                                        name="bodyType"
                                        rules={[{ required: true, message: "Please select a body type!" }]}
                                    >
                                        <Typography style={labelStyle}>Body Type</Typography>
                                        <Select
                                            className="textInput"

                                            style={selectStyle}
                                            placeholder="Select Body Type" value={bodyType} onChange={(value) => setBodyType(value)}>
                                            <Option value="SUV">SUV</Option>
                                            <Option value="Sedan">Sedan</Option>
                                            <Option value="Compact car">Compact car</Option>
                                            <Option value="City car">City car</Option>
                                        </Select>
                                    </Form.Item>


                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' }} >


                                    <Form.Item

                                        rules={[{ required: true, message: "Please enter the color vehicle!" }]}
                                    >
                                        <Typography style={labelStyle}>Color</Typography>
                                        <Input
                                            className="textInput"
                                            value={color} onChange={(e) => setColor(e.target.value)} />
                                    </Form.Item>


                                    <Form.Item
                                        style={selectStyle}
                                        name="fuelType"
                                        rules={[{ required: true, message: "Please select the fuel type!" }]}
                                    >
                                        <Typography style={labelStyle}>Fuel Type</Typography>
                                        <Select
                                            className="textInput"
                                            placeholder="Select a Fuel Type"
                                            value={fuelType} onChange={(value) => setFuelType(value)}>
                                            <Option value="Petrol">Petrol</Option>
                                            <Option value="Diesel">Diesel</Option>
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        name="mileage"
                                        rules={[{ required: true, message: "Please enter the mileage!" }]}
                                    >
                                        <Typography style={labelStyle}>Mileage</Typography>
                                        <Input
                                            className="textInput"
                                            value={mileage} onChange={(e) => setMileage(e.target.value)} />
                                    </Form.Item>



                                    <Form.Item
                                        name="rent"
                                        rules={[{ required: true, message: "Please enter the rent!" }]}
                                    >
                                        <Typography style={labelStyle}>Rent</Typography>
                                        <Input
                                            className="textInput"
                                            type="number" value={rent} onChange={(e) => setRent(e.target.value)} />
                                    </Form.Item>





                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' }} >
                                    <Form.Item
                                    >
                                        <Typography style={labelStyle}>License Exp Date</Typography>
                                        <Input
                                            className="textInput"
                                            type="date"
                                            value={licenseExpDate} onChange={(e) => alert(e.target.value)} />
                                    </Form.Item>
                                    <Form.Item
                                    >
                                        <Typography style={labelStyle}>MOT test date</Typography>
                                        <Input
                                            className="textInput"
                                            type="date"
                                            value={motTestDate}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setMotTestDate(value);
                                                setMotExpDate(new Date(new Date(value).setMonth(new Date(value).getMonth() + 6)));
                                            }} />
                                    </Form.Item>
                                    <Form.Item
                                    >
                                        <Typography style={labelStyle}>MOT Exp Date</Typography>
                                        <Input
                                            className="textInput"
                                            value={new Date(motExpDate).toDateString()}
                                            disabled={true}

                                        />
                                    </Form.Item>
                                    <Form.Item
                                    >
                                        <Typography style={labelStyle}>Tax exp date</Typography>
                                        <Input
                                            className="textInput"
                                            type="date"
                                            value={taxExpDate}
                                            onChange={(e) => setTaxExpDate(e.target.value)} />
                                    </Form.Item>
                                </div>



                                <Form.Item
                                    name="rentalDetails" rules={[{ required: true, message: "Please enter rental details!" }]}
                                >
                                    <Typography style={labelStyle}>Rental Details</Typography>
                                    <Input.TextArea
                                        className="textInput"
                                        value={rentalDetails}
                                        onChange={(e) => setRentalDetails(e.target.value)}
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Add new image" name="images" valuePropName="fileList">
                                    <input type="file" multiple onChange={(e) => setImages(e.target.files)} />
                                </Form.Item>

                                <Row style={{ width: "100%", marginRight: -10 }} >

                                    {vehicle?.images?.length && vehicle.images.map((image, index) => (
                                        <div style={{ marginLeft: 10, position: "relative" }}>
                                            <Image
                                                width={100}
                                                height={100}
                                                key={index}
                                                src={VEH_IMAGE_URL + image}
                                                alt={`Vehicle ${index + 1}`}
                                                style={{ marginBottom: "16px", borderRadius: 10, }}
                                            />
                                            <button
                                                type="button"
                                                onClick={() => removeImages(image)}
                                                style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    right: 0,
                                                    background: "none",
                                                    border: "none",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                ❌
                                            </button>
                                        </div>
                                    ))}
                                </Row>


                                {/* Existing + New Documents Section */}
                                <div style={{ marginTop: 30 }}>
                                    <Typography style={{ fontSize: 18, fontWeight: 600, color: appColors.primary, marginBottom: 15 }}>
                                        Vehicle Documents
                                    </Typography>

                                    {/* Existing Documents */}
                                    {existingDocuments.length > 0 && (
                                        <div style={{ marginBottom: 20 }}>
                                            <Typography style={{ fontSize: 14, marginBottom: 10, color: '#555' }}>Current Documents</Typography>
                                            {existingDocuments.map((doc) => (
                                                <div
                                                    key={doc.doc_id}
                                                    style={{
                                                        padding: 12,
                                                        backgroundColor: deletedDocIds.includes(doc.doc_id) ? '#ffebeb' : '#f9f9f9',
                                                        borderRadius: 8,
                                                        marginBottom: 8,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        border: '1px solid #e0e0e0'
                                                    }}
                                                >
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                                        <span style={{ fontSize: 24 }}>{doc.file_path.endsWith('.pdf') ? '📄' : '🖼️'}</span>
                                                        <div>
                                                            <div style={{ fontWeight: 600 }}>{doc.file_name}</div>
                                                            <div style={{ fontSize: 12, color: '#888' }}>
                                                                {doc.doc_type.replace(/_/g, ' ').toUpperCase()} • {new Date(doc.uploaded_at).toLocaleDateString()}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <Button
                                                        danger
                                                        size="small"
                                                        onClick={() => removeExistingDoc(doc.doc_id)}
                                                    >
                                                        Remove
                                                    </Button>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* Upload New Documents */}
                                    <Upload {...newDocumentUploadProps}>
                                        <Button icon={<UploadOutlined />} size="large">
                                            Add New Documents
                                        </Button>
                                    </Upload>

                                    {newDocumentList.length > 0 && (
                                        <div style={{ marginTop: 16 }}>
                                            {newDocumentList.map((file) => (
                                                <Row key={file.uid} gutter={16} align="middle" style={{ marginBottom: 8, padding: 10, backgroundColor: '#f0f8ff', borderRadius: 6 }}>
                                                    <Col flex="auto">
                                                        <strong>{file.name}</strong>
                                                    </Col>
                                                    <Col flex="250px">
                                                        <Select
                                                            value={file.docType}
                                                            style={{ width: '100%' }}
                                                            onChange={(v) => handleNewDocTypeChange(v, file.uid)}
                                                        >
                                                            <Option value="mot_certificate">MOT Certificate</Option>
                                                            <Option value="pco_license">PCO License</Option>
                                                            <Option value="insurance">Insurance</Option>
                                                            <Option value="road_tax">Road Tax</Option>
                                                            <Option value="vehicle_license">V5C Log Book</Option>
                                                            <Option value="other">Other</Option>
                                                        </Select>
                                                    </Col>
                                                </Row>
                                            ))}
                                        </div>
                                    )}
                                </div>


                                <Form.Item
                                    style={{ textAlign: 'center', }}

                                >
                                    <Button
                                        style={{
                                            height: 40, backgroundColor: appColors.primary, marginTop: 20,
                                            fontFamily: 'Poppins', fontSize: 14, fontWeight: 600, width: 200
                                        }}
                                        type="primary"
                                        htmlType="submit">

                                        Save
                                    </Button>
                                </Form.Item>



                            </Form>


                        </div>



                    </div>
                </div>
            </ThemeProvider>
        </>
    )

}

// const selectStyle = { width: 250 }

const labelStyle = { color: appColors.black, fontSize: 14, fontFamily: 'Poppins', marginTop: 0 }

export default Addvehicle
